import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TextInput from '../TextInput/TextInput';
import SVGIcon from '../SVGIcon/SVGIcon';
import Button from '../Button/Button';

/**
 * The Searchfield component is used to execute a search string.
 * Click the cancel button to reset the search value.
 * This component is based on the TextInput component and interacts with the same properties.
 */

const SearchField = ({
  placeholder = null,
  inputValue = '',
  onChange = null,
  autoFocus = true,
  ...InputAttributes
}) => {
  const [inputText, setInputText] = useState(inputValue);
  const textFieldRef = React.createRef();

  const onInputTextChange = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setInputText(value);
    if (onChange) onChange(value);
  };

  const onClickRightElement = () => {
    setInputText('');
    textFieldRef.current.focus();
    if (onChange) onChange('');
  };

  const searchRightElement = (
    <Button
      contentType="icon"
      type="button"
      size="small"
      icon="cancel"
      dataAttributes={{
        'data-test-button': 'text-clear-input'
      }}
      onClick={onClickRightElement}
    />
  );

  return (
    <TextInput
      {...InputAttributes}
      inputValue={inputText}
      onChange={onInputTextChange}
      ref={textFieldRef}
      placeholder={placeholder || i18n('Type to search...')}
      type="search"
      leftElement={<SVGIcon icon="search" tw="text-black text-opacity-60" />}
      rightElement={inputText.length ? searchRightElement : null}
      autoFocus={autoFocus}
    />
  );
};

SearchField.propTypes = {
  /** Passed through input value */
  inputValue: PropTypes.string,
  /** Fill in a placeholder text  */
  placeholder: PropTypes.string,
  /** onChange event for input field */
  onChange: PropTypes.func,
  /** Add focus to searchfield when loading the page */
  autoFocus: PropTypes.bool
};

export default SearchField;
